import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import RecoveryEmailSent from '../../components/passwordRecovery/RecoveryEmailSent';

class RecoveryEmailSentContainer extends React.Component {
  render() {
    const { isCountryKnown, supportEmail, supportPhoneNumber } = this.props;
    return (
      <RecoveryEmailSent
        isCountryKnown={isCountryKnown}
        supportEmail={supportEmail}
        supportPhoneNumber={supportPhoneNumber}
      />
    );
  }
}

RecoveryEmailSentContainer.propTypes = {
  isCountryKnown: propTypes.bool.isRequired,
  supportEmail: propTypes.string.isRequired,
  supportPhoneNumber: propTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  isCountryKnown: state.supportInfo.referrerCountryCode !== null,
  supportEmail: state.supportInfo.supportEmail,
  supportPhoneNumber: state.supportInfo.supportPhoneNumber
});

export default connect(mapStateToProps)(RecoveryEmailSentContainer);
